import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/at-bat
// @see https://www.baseball-reference.com/bullpen/At_bat
// @see https://baseball.fandom.com/wiki/At_bat
// An official at-bat comes when a batter reaches base via a fielder's choice, hit or an error (not including catcher's interference) or when a batter is put out on a non-sacrifice. (Whereas a plate appearance refers to each completed turn batting, regardless of the result.)
const classifiesAsAtBat = function(paResult) {
    switch (paResult) {
        // Base hits
        case PlateAppearanceResult.Double.key:
        case PlateAppearanceResult.GroundRuleDouble.key:
        case PlateAppearanceResult.HomeRun.key:
        case PlateAppearanceResult.InsideTheParkHomeRun.key:
        case PlateAppearanceResult.Single.key:
        case PlateAppearanceResult.Triple.key:
        // dropped 3rd, todo - verify if it's true
        case PlateAppearanceResult.WildPitch.key:
        case PlateAppearanceResult.PassedBall.key:
        // batter out - strikeout
        case PlateAppearanceResult.SwingingStrikeout.key:
        case PlateAppearanceResult.CalledStrikeout.key:
        case PlateAppearanceResult.FoulTipOut.key:
        case PlateAppearanceResult.FoulOut.key:
        // batter out - other
        case PlateAppearanceResult.BatterInterference.key:
        case PlateAppearanceResult.BatterOut.key:
        case PlateAppearanceResult.FieldOut.key:
        case PlateAppearanceResult.InfieldFly.key:
        // batter safe - other
        case PlateAppearanceResult.FieldersChoice.key:
        case PlateAppearanceResult.ReachedOnError.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsAtBat;